import React from 'react';

const WhyEmblock = () => (
  <div className="py-12 px-6 md:px-16 bg-white text-center">
    <h2 className="text-[24px] md:text-[40px] font-bold text-gray-900 ">
      Why Emblock?
    </h2>
    <p
      className="text-gray-600 text-[14px] md:text-[20px]  mx-auto max-w-5xl"
    >
      Emblock is a dynamic software engineering company offering services in UI/UX design, Frontend and Backend development, Mobile App Development, Digital Marketing, Embedded systems, and Web 3.0 technologies. As an intern, you’ll work on real-world projects with experienced mentors, gaining valuable skills and insights for your future career. You’ll also have the opportunity to explore new technologies, collaborate with diverse teams, and learn industry best practices.
    </p>
  </div>
);

export default WhyEmblock;